module.exports = __webpack_public_path__ + "img/bank-qnb.f9b63779.svg";